import { PersonalDataReturn } from './types';
import api from '..';
import { validateCPF } from '@/utils/validators/cpf';
import useSWR from 'swr';
import { useEffect, useState } from 'react';

export const PersonalDataFetchold = (cpf: string) => {
  const { data, mutate, isLoading } = useSWR<PersonalDataReturn>(
    `personal_data_${cpf}`,
    async (): Promise<PersonalDataReturn> => {
      if (cpf === '' || !validateCPF(cpf)) {
        return {
          found: false,
        };
      }

      const { data } = await api.get(
        `/integrations/dados-pessoais/${cpf.replace(/[^0-9]+/g, '')}`,
      );
      return data as PersonalDataReturn;
    },
  );

  return { data, mutate, isLoading };
};
export const PersonalDataFetch = (cpf: string) => {
  const [data, setData] = useState<{ found: boolean }>();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (cpf === '' || !validateCPF(cpf)) {
      setData({ found: false });
      return;
    }

    const timer = setTimeout(() => {
      setIsLoading(true);
      api
        .get(`/integrations/dados-pessoais/${cpf.replace(/[^0-9]+/g, '')}`)
        .then((response) => {
          setData(response.data);
        })
        .catch(() => {
          setData({ found: false });
        })
        .finally(() => setIsLoading(false));
    }, 400);

    return () => clearTimeout(timer);
  }, [cpf]);

  return { data, isLoading };
};
